import { BaseModalV2 } from 'components/ui/BaseModal'
import { IPop } from 'constants/interfaces'
import React, { useState } from 'react'
import { StartConversationsBlock } from '../StartConversationsBlock'
import { ModalHeaderWithClose } from '../ModalHeaderWithClose'
import { AiRepopBody } from './AiRepopBody'
import { useChatGptSessionCleanup } from '../hooks/useChatGptSessionCleanup'
import { TriangleActionsPanel } from './TriangleActionsPanel'
import { Box } from '@chakra-ui/core'
import { PopType } from 'components/PopOverview/utils'

interface IProps {
  isOpen: boolean
  handleSubmit: (popType: number | undefined) => void
  aiRepop: IPop
}

export const AiRepop = ({ isOpen, handleSubmit, aiRepop }: IProps) => {
  const { repop_main_btn, ack_btn_text } = aiRepop
  const handleClose = (popType: number | undefined) => {
    handleSubmit(popType)
  }

  useChatGptSessionCleanup()

  const [editMode, setEditMode] = useState(false)

  return (
    <BaseModalV2
      modalContentProps={{
        borderRadius: '50px',
        width: '100%',
        maxW: '32rem',
      }}
      modalHeaderProps={{
        boxShadow: 'none',
        pb: '30px',
        position: 'relative',
      }}
      modalBodyProps={{
        backgroundColor: 'white',
        height: '100%',
        minHeight: '270px',
      }}
      isOpen={isOpen}
      onClose={() => handleSubmit(PopType.DEFAULT_POP)}
      header={
        <ModalHeaderWithClose aiPop={aiRepop} onClose={() => handleSubmit(PopType.DEFAULT_POP)} editMode={editMode} />
      }
      body={<AiRepopBody aiRepop={aiRepop} editMode={editMode} setEditMode={setEditMode} />}
      footer={
        <>
          <StartConversationsBlock pop={aiRepop} handleClose={handleClose} editMode={editMode} />
          <Box position="absolute" top="calc(100% + 30px)" left="50%" transform="translateX(-50%)">
            <TriangleActionsPanel
              handleClose={handleClose}
              declineBtnText={repop_main_btn || ''}
              acceptBtnText={ack_btn_text || ''}
              editMode={editMode}
            />
          </Box>
        </>
      }
    />
  )
}
